import React from 'react';
import { Helmet } from 'react-helmet-async';
import NavBar from '../components/Navbar';
import Footer from '../components/Footer';
import { generateWhatsAppLink } from '../utils/whatsapp';

const PostoCombustivel = () => {
  const wpp = generateWhatsAppLink('posto', 'posto-page');
  return (
    <div>
      <Helmet>
        <title>Luminárias de LED para Postos de Combustível | Sustenta LED</title>
        <meta name="description" content="LED para postos de combustível: marquises, pista e áreas internas. Somos atacadistas e distribuidores com soluções homologadas." />
      </Helmet>
      <NavBar />
      <section className="section" style={{ paddingTop: '120px' }}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h1 style={{fontWeight: 900}}>Luminárias de LED para Postos de Combustível</h1>
              <p>Oferecemos LED para marquises, pistas de abastecimento e áreas internas de conveniência. Somos atacadistas e distribuidores com produtos homologados e eficientes.</p>
              <p>Indicamos soluções com alto fluxo luminoso e proteção adequada (IP) para ambientes externos.</p>
              <p>Solicite cotação e receba atendimento especializado para seu posto.</p>
              <div className="d-flex flex-column align-items-start">
                <a className="btn btn-success d-inline-flex align-items-center justify-content-center gap-2" href={wpp} target="_blank" rel="noopener noreferrer">
                  <i className="bi bi-whatsapp" style={{ fontSize: '18px', lineHeight: 1 }}></i>
                  Solicite agora a sua cotação e receba em até 1h
                </a>
                <button type="button" className="btn btn-outline-secondary mt-2" onClick={() => window.history.back()}>
                  Voltar à página anterior
                </button>
              </div>
            </div>
            <div className="col-lg-6">
              <img src="/img/banner_como_trabalhamos.jpg" alt="LED para Postos de Combustível - Sustenta LED" className="img-fluid rounded" />
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default PostoCombustivel;
